<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.beneficiaryservice.list') }}
      </h1>

      <div class="card rounded-0 mb-4">
        <form class="card-body">
          <div class="row mb-2">
            <!-- Distributor -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedDistributorRef') }} *
              </label>
              <select
                v-model="criterias.selectedDistributorRef"
                :disabled="isDistributorLocked"
                :class="status(v$.criterias.selectedDistributorRef)"
                name="distributor"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.account.selectedDistributorRef')"
                @change="updateComProducts()"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.account.selectedDistributorRef') }}
                </option>
                <option
                  v-for="distributor in distributors"
                  :key="distributor.id"
                  :value="distributor"
                >
                  {{ distributor }}
                </option>
              </select>
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedDistributorRef.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
              </p>
            </div>

            <!-- Produit commercial -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedCommercialProduct') }}
              </label>
              <select
                v-model="criterias.selectedCommercialProduct"
                :class="status(v$.criterias.selectedCommercialProduct)"
                name="commercialProduct"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.account.selectedCommercialProduct')"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.account.selectedCommercialProduct') }}
                </option>
                <option
                  v-for="product in comProducts"
                  :key="product.id"
                  :value="product"
                >
                  {{ product }}
                </option>
              </select>
            </div>

            <!-- Contrat financeur -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedFunderContract') }}
              </label>
              <input
                v-model="criterias.selectedFunderContract"
                :class="status(criterias.selectedFunderContract)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.account.selectedFunderContract')"
              >
            </div>

            <!-- Service beneficiaire -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedBeneficiaryService') }}
              </label>
              <input
                v-model="criterias.selectedBeneficiaryService"
                :class="status(v$.criterias.selectedBeneficiaryService)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.account.selectedBeneficiaryService')"
              >
            </div>
          </div>

          <div class="row mb-2">
            <!-- Account Status -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.beneficiaryStatus') }}
              </label>
              <select
                v-model="criterias.selectedBeneficiaryServiceStatus"
                :class="status(v$.criterias.selectedBeneficiaryServiceStatus)"
                name="accountStatus"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.account.beneficiaryStatus')"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.account.beneficiaryStatus') }}
                </option>
                <option value />
                <option
                  v-for="type in beneficiaryServiceStatus"
                  :key="type.id"
                  :value="type"
                >
                  {{ type }}
                </option>
              </select>
            </div>

            <!-- Start Date traitement-->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedCreationDate') }}
              </label>
              <input
                v-model="criterias.selectedCreationDate"
                :class="status(v$.criterias.selectedCreationDate)"
                type="date"
                class="form-control rounded-0"
                placeholder="yyyy-MM-dd"
              >
            </div>

            <!-- Start Date traitement-->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.account.selectedClosingDate') }}
              </label>
              <input
                v-model="criterias.selectedClosingDate"
                :class="status(v$.criterias.selectedClosingDate)"
                type="date"
                class="form-control rounded-0"
                placeholder="yyyy-MM-dd"
              >
            </div>

            <div class="col justify-content-end text-end criteria-button">
              <button
                type="button"
                class="btn btn-default btn-reset rounded-pill font-custom me-2"
                @click="reset()"
              >
                {{ $t('button.reset') }}
              </button>
              <button
                class="btn btn-primary btn-submit rounded-pill font-custom text-uppercase font-inverted"
                type="button"
                @click="search()"
              >
                <i class="fa fa-search me-1" />
                {{ $t('button.search') }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div v-if="$store.state.beneficiaries.beneficiaries.length">
        <div class="table-responsive">
          <table
            class="table table-hover table-sm table-striped border"
            style="white-space:nowrap;"
          >
            <thead>
              <tr>
                <th>{{ $t('label.account.selectedDistributorRef') }}</th>
                <th>{{ $t('label.account.selectedCommercialProduct') }}</th>
                <th>{{ $t('label.account.selectedFunderContract') }}</th>
                <th>{{ $t('label.account.selectedBeneficiaryService') }}</th>
                <th>{{ $t('label.account.beneficiaryStatus') }}</th>
                <th>{{ $t('label.account.selectedCreationDate') }}</th>
                <th>{{ $t('label.account.selectedClosingDate') }}</th>
                <th>{{ $t('label.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="beneficiaryService in displayedBeneficiaryServices"
                :key="beneficiaryService.id"
                class="mb-3"
              >
                <td>{{ beneficiaryService.distributorRef }}</td>
                <td>{{ beneficiaryService.productRef }}</td>
                <td>{{ beneficiaryService.funderContractRef }}</td>
                <td>{{ beneficiaryService.beneficiaryServiceRef }}</td>
                <td>{{ beneficiaryService.beneficiaryState }}</td>
                <td>{{ $filters.dateYYYYMMDD(beneficiaryService.creationDate) }}</td>
                <td>{{ $filters.dateYYYYMMDD(beneficiaryService.closureDate) }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom"
                    @click="showDetails(beneficiaryService)"
                  >
                    {{ $t('button.detail') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <Pager
          :posts="$store.state.beneficiaries.beneficiaries"
          @page-update="displayedBeneficiaryServices = $event;"
        />
      </div>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="center-block lazyload"
        >
      </div>

      <div
        v-else-if="error"
        class="alert alert-warning text-center border-0 shadow-sm rounded-0"
      >
        {{ $t('error.'+`${responseErr}`) }}
      </div>
    </div>
  </div>
</template>

<script src="./BeneficiaryList.js"></script>

<style src="./BeneficiaryList.scss" scoped lang="scss"></style>
